export const commonColumns = {
    name: { id: "name", label: "Name", minWidth: 150 },
    email: { id: "email", label: "Email", minWidth: 180 },
    phoneNumber: { id: "phoneNumber", label: "Phone Number", minWidth: 130 },
    actions: { id: "actions", label: "Actions", align: "right", minWidth: 150 },
};

const createTableColumn = (id, label, config = {}) => ({ id, label, ...config });

export const userManagementColumns = {
    manager: [
        createTableColumn("username", "Username", { minWidth: 120 }),
        createTableColumn("role", "Role", { minWidth: 120 }),
        createTableColumn("region", "Region", { minWidth: 120 }),
        createTableColumn("area", "Area", { minWidth: 120 }),
    ],
    consultant: [
        commonColumns.name,
        commonColumns.email,
        createTableColumn("phoneNumber", "Mobile Number", { minWidth: 130 }),
        createTableColumn("companyName", "Company Name", { minWidth: 160 }),
        createTableColumn("professionalWebsite", "Website", { minWidth: 150, maxWidth: 200 }),
        createTableColumn("yearsOfExperience", "Experience", { minWidth: 140 }),
        createTableColumn("loanSpecialization", "Loan Specialization", { minWidth: 220 }),
        createTableColumn("status", "Status", { minWidth: 120 }),
    ],
    lender: [
        createTableColumn("id", "User ID", { minWidth: 100 }),
        createTableColumn("uuid", "Lender ID", { minWidth: 120 }),
        commonColumns.name,
        commonColumns.email,
        createTableColumn("phoneNumber", "Mobile Number", { minWidth: 130 }),
        createTableColumn("financierType", "Institution Type", { minWidth: 150 }),
        createTableColumn("typeOfLending", "Type of Lending", { minWidth: 150 }),
        createTableColumn("typeOfRetailLoans", "Retail Loans", { minWidth: 150 }),
        createTableColumn("designation", "Designation", { minWidth: 130 }),
        createTableColumn("taggedLocation", "Location", { maxWidth: 250 }),
        createTableColumn("verificationStatus", "Status", { minWidth: 120 }),
    ],
    borrower: [
        createTableColumn("businessType", "Business Type", { minWidth: 180 }),
        createTableColumn("taggedLocation", "Location", { maxWidth: 250 }),
    ],
};

const standardColumns = {
    date: { id: "date", label: "Date" },
    phone: { id: "phone", label: "Phone" },
    status: { id: "status", label: "Status" },
    source: { id: "source", label: "Source" },
};

export const leadsColumns = {
    advisorBase: [standardColumns.date, standardColumns.phone, standardColumns.status, standardColumns.source],
    elicalBase: [standardColumns.date, standardColumns.phone, standardColumns.status],
};

export const loansColumns = {
    columns: [
        createTableColumn("applicationNumber", "Application Number" , { minWidth: 50, maxWidth: 120 }),
        createTableColumn("borrowerName", "Borrower Name" , { minWidth: 50, maxWidth: 100 }),
        createTableColumn("mobileNumber", "Mobile Number", { minWidth: 50, maxWidth: 100 }),
        createTableColumn("amount", "Amount", { minWidth: 50, maxWidth: 100 }),
        createTableColumn("submittedDate", "Submitted Date", { minWidth: 50, maxWidth: 120 }),
        createTableColumn("status", "Status", { minWidth: 50, maxWidth: 70 }),
        createTableColumn("reports", "Reports", { minWidth: 50, maxWidth: 120 }),
        createTableColumn("actions", "Actions", { minWidth: 50, maxWidth: 150 }),
        createTableColumn("offers", "Offers", { minWidth: 50, maxWidth: 100 }),
    ],
};

export const offersColumns = {
    columns: [
        createTableColumn("offerId", "Offer ID"),
        createTableColumn("loanOffered", "Loan Amount"),
        createTableColumn("rateOfIntrest", "Interest Rate"),
        createTableColumn("repaymentTenure", "Tenure (Months)"),
        createTableColumn("processingFees", "Processing Fees"),
        createTableColumn("lenderId", "Lender ID"),
        createTableColumn("createOpName", "Created By"),
        createTableColumn("status", "Status"),
        createTableColumn("submittedDate", "Created Date"),
        createTableColumn("actions", "Actions", { align: "center" }),
    ],
};

export const contentColumns = {
    columns: [
        createTableColumn("title", "Title", { maxWidth: 400 }),
        createTableColumn("contentType", "Content Type"),
        createTableColumn("sortOrder", "Sort Order"),
        createTableColumn("isActive", "Active"),
        createTableColumn("published", "Published"),
        createTableColumn("publishedDate", "Created At"),
        createTableColumn("actions", "Actions", { align: "center" }),
    ],
};

export const eligibilityCalculatorColumns = {
    columns: [
        createTableColumn("entityName", "Entity Name"),
        createTableColumn("entityType", "Entity Type"),
        createTableColumn("businessType", "Business Type"),
        createTableColumn("businessAge", "Business Age (Years)"),
        createTableColumn("totalSales", "Total Sales (INR)"),
        createTableColumn("annualProfit", "Annual Profit (INR)"),
        createTableColumn("fundsUsed", "Funds Used"),
        createTableColumn("emiHistory", "EMI History"),
        createTableColumn("loanAmount", "Loan Amount (INR)"),
        createTableColumn("interestRate", "Interest Rate (%)"),
        createTableColumn("loanTenure", "Loan Tenure (Years)"),
        createTableColumn("emiAmount", "Estimated EMI (INR)"),
        createTableColumn("totalInterestAmount", "Total Interest (INR)"),
        createTableColumn("totalRepaymentAmount", "Total Repayment (INR)"),
        createTableColumn("instantApprovalScore", "Instant Approval Score"),
        createTableColumn("eligibleLoanAmount", "Eligible Amount (Lakhs)"),
        createTableColumn("securedProducts", "Secured Products"),
        createTableColumn("unsecuredProducts", "Unsecured Products"),
    ],
};

const preventObjectChanges = (obj) => {
    if (obj == null || Object(obj) !== obj) return Object.freeze(obj);    
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (value != null && Object(value) === value) {
            preventObjectChanges(value);
        }
    }
    return Object.freeze(obj);
};

const preventColumnChanges = (...columnObjects) => {
    columnObjects.forEach(preventObjectChanges);
};

preventColumnChanges(
    commonColumns,
    userManagementColumns,
    leadsColumns,
    loansColumns,
    offersColumns,
    contentColumns
);

export const withActionsColumn = (columns, permission) => {
    try {
        const hasActionPermission = !!(permission && (permission.view === 1 || permission.edit === 1 || permission.delete === 1));
        return hasActionPermission ? [...columns, commonColumns.actions] : columns;
    } catch {
        return columns;
    }
};